exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#leftContainer {\n  width: 50%;\n  height: calc(50% * .665);\n  position: relative;\n  float: left; }\n\n#rightContainer {\n  width: 50%;\n  height: calc(50% * .665);\n  position: relative;\n  float: right; }\n\n#images {\n  width: 100%;\n  height: calc(50vw * .665); }\n\n#mainImageContainer {\n  display: flex;\n  justify-content: center; }\n\n#mainImage {\n  max-height: 75vh; }\n\n#mainImageContainer img {\n  max-height: 70vh; }\n", ""]);

// exports
